import { Button, Row, Space } from "antd";
import Title from "antd/lib/typography/Title";
import React from "react";
import Typist from "react-typist-component";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faApple, faAndroid } from "@fortawesome/free-brands-svg-icons";
import { faMap, faBell } from "@fortawesome/free-regular-svg-icons";
import {
  faGlobe,
  faCheck,
  faSync,
  faListUl,
  faSearch,
  faZap,
  faServer,
  faExternalLink,
  faBook,
  faTablet,
  faTabletScreenButton,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import FeatureWithIcon from "../components/FeatureWithIcon";
import SubscriptionBusinessAppsCard from "../components/SubscriptionBusinessAppsCard";
import SubscriptionBusinessApiCard from "../components/SubscriptionBusinessApiCard";

export default function HomeContent() {
  const [count, setCount] = React.useState(1);

  React.useEffect(() => {
    // document.title = `You clicked ${count} times`;
    console.log("Count: " + count);
    setCount(1);
  }, [count]);

  return (
    <>
      <div
        className="landing-section landing-section-background landing-section-first"
        id="top"
      >
        <div className="landing-header">
          <div className="landing-header-content">
            <h1>
              MOBILE APPS <br />
              FOR <br />
              <div
                style={{
                  color: "#72DDEB",
                  minHeight: "2em",
                }}
              >
                <Typist key={count} onTypingDone={() => setCount(count + 1)}>
                  PILOTS
                  <Typist.Delay ms={800} />
                  <Typist.Backspace count={6} />
                  ATC
                  <Typist.Delay ms={800} />
                  <Typist.Backspace count={3} />
                  GROUND CREW
                  <Typist.Delay ms={800} />
                  <Typist.Backspace count={11} />
                  OPERATORS
                  <Typist.Delay ms={800} />
                  <Typist.Backspace count={9} />
                </Typist>
              </div>
            </h1>

            <p>
              The CTOT app lets you view real-time CTOT details for flights
              across European airspace.
            </p>
            <Space wrap className="landing-app-links">
              <a
                href="https://apps.apple.com/app/ctot/id1513174766#?platform=iphone"
                target="blank"
              >
                <Button type="primary" size="large">
                  <FontAwesomeIcon icon={faApple} style={{ width: 15 }} />
                  &nbsp;Download iOS App
                </Button>
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=app.ctot.ctotapp"
                target="blank"
              >
                <Button type="primary" size="large">
                  <FontAwesomeIcon icon={faAndroid} style={{ width: 15 }} />
                  &nbsp;Download Android App
                </Button>
              </a>
              <a href="https://dashboard.ctot.app">
                <Button type="primary" size="large">
                  <FontAwesomeIcon icon={faGlobe} style={{ width: 15 }} />
                  &nbsp;Web Version
                </Button>
              </a>
            </Space>
          </div>

          <div className="landing-header-content">
            <div className="container-header-image">
              <img
                src="/images/screenshots/alldevices2.png"
                alt="App screenshots"
                className="landing-header-image"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="landing-section" id="features">
        <h1>OPTIMIZE YOUR OPERATIONAL PERFORMANCE</h1>
        <p>
          CTOT is built for efficiency. Crews use it on the ramp and in the
          cockpit to resolve <span className="blue">flight plan issues</span>.
          Empower your team!
        </p>
        <br />
        <Row style={{ justifyContent: "center" }}>
          <div className="landing-features">
            <div direction="vertical" className="landing-features-list">
              <FeatureWithIcon
                title="Search flight"
                subtitle="Look up flights by registration, flight number, or airport."
                icon={faSearch}
                textAlign="right"
              />
              <FeatureWithIcon
                title="Flight data"
                subtitle="See flight plan status, CTOT, EOBT, TSAT, and more."
                icon={faCheck}
                textAlign="right"
              />
              <FeatureWithIcon
                title="Live information"
                subtitle="Access up-to-date data. Supports iOS Live Activity."
                icon={faSync}
                textAlign="right"
              />
            </div>

            <div className="landing-features-image">
              <img
                src="/images/screenshots/details3.png"
                alt="App details screenshot"
                width="100%"
              />
            </div>

            <div direction="vertical" className="landing-features-list">
              <FeatureWithIcon
                title="Notifications"
                subtitle="Get alerts when your CTOT changes or is assigned."
                icon={faBell}
                reverse
              />

              <FeatureWithIcon
                title="Restriction details map"
                subtitle="Find CTOT restrictions and view detailed information."
                icon={faMap}
                reverse
              />

              <FeatureWithIcon
                title="Watchlist"
                subtitle="Add flights to your watchlist for quick access."
                icon={faListUl}
                reverse
              />
            </div>
          </div>
        </Row>
      </div>

      <div className="landing-section center">
        <h1>ACCESS FROM ANY LOCATION</h1>
        <p>
          Whether you're in the office, cockpit, or on the apron, CTOT offers
          solutions to improve your access to flight plan data.
        </p>
        <Row style={{ justifyContent: "center" }}>
          <Space wrap>
            <div style={{ width: "25vw" }}>
              <img
                className="img-fluid"
                src="/images/screenshots/macbook.png"
                alt="Macbook screenshot"
                width="100%"
              />
            </div>
            <div style={{ width: "8vw" }}>
              <img
                className="img-fluid"
                src="/images/screenshots/notifications.png"
                alt="Map screenshot"
                width="100%"
              />
            </div>
            <div style={{ width: "15vw" }}>
              <img
                className="img-fluid"
                src="/images/screenshots/ipad.png"
                alt="Map screenshot"
                width="100%"
              />
            </div>

            <Space direction="vertical" style={{ width: 300 }}>
              <FeatureWithIcon
                title="Web Version"
                subtitle="Monitor all your flights and identify flight plan issues."
                icon={faGlobe}
                reverse
              />
              <FeatureWithIcon
                title="iOS App"
                subtitle="Available on the App Store."
                icon={faApple}
                reverse
              />
              <FeatureWithIcon
                title="Android App"
                subtitle="Available on the Play Store."
                icon={faAndroid}
                reverse
              />
            </Space>
          </Space>
        </Row>
      </div>

      <div
        className="landing-section landing-section-contact"
        id="integrations"
      >
        <h1 style={{ textAlign: "center", marginBottom: 0 }}>INTEGRATIONS</h1>
        <p style={{ textAlign: "center" }}>
          Integrate CTOT data into your business applications. We support{" "}
          <strong>ad hoc integrations</strong> with our apps, as well as API
          access for <strong>custom solutions.</strong>
        </p>
        <div className="landing-section-integrations">
          <FeatureWithIcon
            title="API and Webhooks"
            subtitle={
              <>
                Access your flight data and receive webhook notifications
                directly via the API — no app required. <br />
                Build custom integrations.
                <br /> <br />
                Manage user access to CTOT apps. <br />
                <br />
                <Link to={"mailto:contact@ctot.app"}>
                  <Button type="primary" size="large">
                    <FontAwesomeIcon icon={faBook} />
                    &nbsp;&nbsp;Contact us for Documentation
                  </Button>
                </Link>
              </>
            }
            icon={faServer}
            reverse
            vertical
          />
          <FeatureWithIcon
            title="EFB Integration"
            subtitle={
              <>
                Use our EFB integration to access CTOT data directly in your
                Electronic Flight Bag (EFB) app.
                <br />
                <br />
                <Link to={"mailto:contact@ctot.app"}>
                  <Button type="primary" size="large">
                    <FontAwesomeIcon icon={faBook} />
                    &nbsp;&nbsp;Contact us for Documentation
                  </Button>
                </Link>
              </>
            }
            icon={faTabletScreenButton}
            reverse
            vertical
          />
          <FeatureWithIcon
            title="Automate with Zapier"
            subtitle={
              <>
                Create automations with Zapier—no coding required. Set up in
                minutes.
                <br />
                For example: send SMS on CTOT changes or consolidate flight data
                in spreadsheets.
                <br />
                <br />
                <a href="https://zapier.com" target="_blank">
                  <Button type="primary" size="large">
                    <FontAwesomeIcon icon={faExternalLink} />
                    &nbsp;&nbsp;See what{" "}
                    <img
                      src="/images/zapier-logo.png"
                      height={17}
                      style={{
                        paddingBottom: 1,
                        marginLeft: 5,
                        marginRight: 5,
                      }}
                    />{" "}
                    can do
                  </Button>
                </a>
              </>
            }
            //icon={faZap}
            imageSource={"/images/zapier-logo.png"}
            reverse
            vertical
          />
         {/*  <FeatureWithIcon
            title="AERIEL Airline Management"
            subtitle={
              <>
                Aeriel is a powerful management and flight scheduling software
                designed for business aircraft operators and airlines.
                <br />
                It is a real-time online application with unique AI features
                that keeps your team up-to-date, helps you with routine tasks
                and makes your data available to anyone, anywhere.
                <br />
                <br />
                <a href="https://aeriel.cz" target="_blank">
                  <Button type="primary" size="large">
                    <FontAwesomeIcon icon={faExternalLink} />
                    &nbsp;&nbsp;See what Aeriel can do
                  </Button>
                </a>
              </>
            }
            imageSource={"/images/aeriel-logo.png"}
            reverse
            vertical
          /> */}
        </div>
      </div>

      <div className="landing-section" id="pricing">
        <h1 style={{ textAlign: "center" }}>PRICING</h1>
        <Space align="block" size={40} wrap>
          <SubscriptionBusinessAppsCard />
          <SubscriptionBusinessApiCard />
        </Space>
      </div>

      <div
        className="landing-section landing-section-contact"
        id="contact"
        style={{ justifyContent: "center" }}
      >
        <div className="center" style={{ marginTop: 0, paddingTop: 0 }}>
          <Title level={1}>CONTACT</Title>
          Feel free to reach out to us!
          <br />
          <a className="blue" href="mailto:contact@ctot.app">
            <h3 className="blue">contact@ctot.app</h3>
          </a>
        </div>
      </div>
    </>
  );
}
